module.exports = __webpack_public_path__ + "Legal_Header_new.ab2497f0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Legal_Header_new.png
// module id = vo64
// module chunks = 0